import { iframeStep } from './iframeStep';
import { infoStep } from './infoStep';

export const drinkfree = {
  namespaced: true,
  modules: {
    iframeStep,
    infoStep
  }
};
